import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=1cb935a2"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb935a2')) {
      api.createRecord('1cb935a2', component.options)
    } else {
      api.reload('1cb935a2', component.options)
    }
    module.hot.accept("./CloseIcon.vue?vue&type=template&id=1cb935a2", function () {
      api.rerender('1cb935a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/CloseIcon.vue"
export default component.exports